import { ReactNode } from "react";
import { Box, Typography } from "@mui/material";
import "../../components-styles.scss";
import BackButton from "../../UIElements/BackButton";

type ProfilLayoutProps = {
    children: ReactNode;
    headerTitle: string;
    onBackClick: Function;
};

export default function ProfilLayout({
    children,
    headerTitle,
    onBackClick,
}: ProfilLayoutProps) {
    return (
        <>
            <header className="layout-header">
                <Box
                    sx={{
                        marginLeft: "6rem",
                        marginTop: "5vh",
                        marginRight: "1.5rem",
                        marginBottom: "2rem",
                        display: "flex",
                        flexDirection: "column",
                        gap: "2.28rem",
                        "@media (max-width:1024px)": {
                            marginTop: "2vh",
                            marginLeft: "1.5rem",
                        },
                    }}
                >
                    <BackButton back={onBackClick} />
                    <Typography
                        sx={{
                            color: "#005499",

                            fontFamily: "Roboto",
                            fontSize: "1.75rem",
                            fontStyle: "normal",
                            fontWeight: "500",
                            lineHeight: "normal",
                        }}
                    >
                        {headerTitle}
                    </Typography>
                </Box>
            </header>
            <main className="layout-body" style={{ overflow: "hidden" }}>
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        gap: "3rem",
                        marginLeft: "6rem",
                        marginRight: "6rem",
                        marginTop: "2rem",
                        width: "100%",
                        "@media (max-width:1024px)": {
                            marginRight: "1.5rem",
                            marginLeft: "1.5rem",
                            width: "100vh",
                        },
                        "@media (min-width: 600px) and (max-width:1024px)": {
                            width: "100vw",
                        },
                    }}
                >
                    {children}
                </Box>
            </main>
        </>
    );
}
